export { default } from './ForecastDayHeading';
